import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { RegionDto } from '@/modules/counterparty/dto/region.dto.ts';
import type { Region } from '@/modules/counterparty/types/region.type.ts';

export class RegionAdapter {
  private static map(response: RegionDto): Region {
    return {
      id: Number(response.REGION_ID),
      name: response.Название,
      tzId: Number(response.TZ_ID),
      center: response.Центр,
      note: response.Примечание,
    };
  }

  static mapList(response: ItemsDto<RegionDto>) {
    return response.items.map(RegionAdapter.map);
  }
}
